import React, { useState } from 'react';

import { useInputChange } from '../../helpers/useInputChange'
import { useTranslation } from 'react-i18next';
import { postJson } from '../../helpers/RequestsHelper';

const VerifyEmailPage = (props) => {

  var cognitoUser = window.userPool.getCurrentUser()
  var userData = JSON.parse(cognitoUser.getUserDataFromCache())
  const emailAttribute = userData.UserAttributes.find(a => a.Name === "email")

  const [email, setEmail] = useInputChange(emailAttribute.Value)
  const [code, setCode] = useInputChange(props.code)
  const [error, setError] = useState()
  const {t} = useTranslation()

  const onSubmit = (e) => {
    e.preventDefault();
    let button = e.currentTarget;
    if (button.clicked) {
      return
    }
    button.clicked = true
    const verificationCode = code
    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          button.clicked = false
          setError(err.message)
          return;
        }
        cognitoUser.verifyAttribute('email', verificationCode, this);
        postJson(process.env.REACT_APP_SERVER_BASE_URL +"/updateProfile", {});
      })
    }
  }

  document.title = t("titleappname") + t("title_verify_email")

  return <div className="wrap-login100">
    <form className="login100-form validate-form" onSubmit={onSubmit}>
      <h3>{t("title_verify_email")}</h3>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_email")}</span>
        <input className="input100"
          type="email"
          name="email"
          autoComplete="email"
          id="email"
          placeholder={t("tip_email")}
          value={email}
          onChange={setEmail}
          required={true} 
          disabled={true} />
        <span className="focus-input100" data-symbol="&#xf1fa;"></span>
      </div>
      <div className="wrap-input100 validate-input">
        <span className="label-input100">{t("lbl_code")}</span>
        <input className="input100"
          type="text"
          name="code"
          autoComplete="off"
          id="code"
          placeholder={t("tip_code")}
          value={code}
          onChange={setCode} 
          required={true}
          pattern="^\d{6}$" title={t("val_code")}/>
        <span className="focus-input100" data-symbol="&#xf292;"></span>
      </div>
      <br />
      {error ? <small id="errorMessage" className="text-danger">{error}<br/></small> : ""}
      <br />
      <div>
        <input type="submit" className="submit-btn" value={t("btn_confirmation_submit")} />
      </div>
    </form>
  </div>
}

export default VerifyEmailPage
